@let spaceForSiblings = value();
{{ spaceForSiblings ? 'Ja' : 'Nee' }}
